import { createApi } from '@reduxjs/toolkit/query/react';
import { axiosBaseQuery } from 'utils/axiosBaseQuery';

// Define a service using a base URL and expected endpoints
export const currentApi = createApi({
  reducerPath: 'currentApi',
  baseQuery: axiosBaseQuery(),
  tagTypes: ['current'],
  keepUnusedDataFor: 0,
  endpoints: (builder) => ({
    getCurrentList: builder.query({
      query: () => ({
        method: 'GET',
        path: `ServiceTypes`,
      }),
      providesTags: ['current'],
    }),
    getCurrentById: builder.query({
      query: ({ id }) => ({
        method: 'GET',
        path: `Customer/GetCustomer/${id}`,
      }),
    }),
    searchCurrentList: builder.query({
      query: ({ filter }) => ({
        method: 'GET',
        path: `Customer/GetSearchCustomers/${filter}`,
      }),
    }),
    createNewCustomer: builder.mutation({
      query: ({ data }) => ({
        data,
        method: 'POST',
        path: 'login/PublicRegister',
      }),
    }),
    createNewCurrent: builder.mutation({
      query: ({ data }) => ({
        data,
        method: 'POST',
        path: 'Customer/CreateOrUpdateCustomer',
      }),
    }),
    deleteCurrent: builder.mutation({
      query: ({ id }) => ({
        method: 'DELETE',
        path: `Customer/RemoveCustomer/${id}`,
      }),
      invalidatesTags: ['current'],
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const currentApiReducerName = currentApi.reducerPath;
export const currentApiReducer = currentApi.reducer;
export const currentApiMiddleware = currentApi.middleware;

export const {
  useGetCurrentListQuery,
  useSearchCurrentListQuery,
  useDeleteCurrentMutation,
  useCreateNewCurrentMutation,
  useGetCurrentByIdQuery,
} = currentApi;
